import { NULL_LABEL, NULL_STR } from '#/config/consts';

export const conditions = {
  good: { value: 'good', text: 'Good' },
  fair: { value: 'fair', text: 'Fair' },
  poop: { value: 'poor', text: 'Poor' },
};

export const conditionsList = Object.values(conditions);
